import { type Signal, useComputed } from "@suse-o11y/signal";
import type { SignalForm } from "@suse-o11y/signal/form";
import React from "react";

import { useFormFieldDelayedError } from "./_use-form-field-delayed-error";
import { FormMessage } from "./message";

/**
 * The error message displayed when no other FormMessage.variant=error are present in the same FormField.
 */
export const FallbackErrorMessage: React.FC<{
	state: SignalForm;
	errorMessageDescendants: Signal<number>;
}> = ({ state, errorMessageDescendants }) => {
	const delayedErrorMessage = useFormFieldDelayedError(state);

	const hasErrorDescendants = useComputed(
		(monitor) => errorMessageDescendants.read(monitor) > 0,
		[errorMessageDescendants],
	);

	// only show the fallback error message if there are no other error messages in the FormField
	if (hasErrorDescendants || delayedErrorMessage == null) {
		return null;
	}

	return <FormMessage variant="error">{delayedErrorMessage}</FormMessage>;
};
